
export enum TableHelpContentType {

    TableColumnType = "table_column_type",
    TableFooterType = "table_footer_type"

}